import { SHIPMENT_FILTERS } from '../stores/shipmentStats'

function toDateUTC(value: any): Date | null {
  if (!value) return null
  const d = new Date(value)
  if (isNaN(d.getTime())) return null
  d.setUTCHours(0, 0, 0, 0)
  return d
}

function todayUTC(): Date {
  const d = new Date()
  d.setUTCHours(0, 0, 0, 0)
  return d
}

// Firestore: shipment.milestones.eta (nested object)
// BigQuery:  shipment.eta             (flat, sin prefijo milestones)
function milestone(shipment: any, field: string): any {
  return shipment.milestones?.[field] ?? shipment[field] ?? null
}

// "En tránsito" = todavía no llega (sin ATA), como lo describe la tarjeta y como lo
// resuelve el backend (cardFilter IN_TRANSIT = "ata IS NULL"). No usar isTracking: el
// rastreo sigue encendido despues de la entrega hasta que alguien lo apaga a mano.
export function isInTransit(shipment: any): boolean {
  return !isArrived(shipment)
}

// "Retrasado" = se cumplio una fecha estimada y todavia no hay fecha real, como lo
// describe la tarjeta y como lo resuelve el backend (cardFilter DELAYED). No entran
// ni el ETA posterior a la fecha de entrega solicitada ni el ETA pospuesto por
// notificacion: marcaban embarques que aun van en fecha.
export function isDelayed(shipment: any): boolean {
  if (shipment.status === 'COMPLETED') return false

  const today = todayUTC()
  const eta = toDateUTC(milestone(shipment, 'eta'))
  const etd = toDateUTC(milestone(shipment, 'etd'))
  const atd = toDateUTC(milestone(shipment, 'atd'))
  const ata = toDateUTC(milestone(shipment, 'ata'))

  const isEtaOverdue = eta && eta < today && !ata
  const isEtdOverdue = etd && etd < today && !atd

  return !!(isEtaOverdue || isEtdOverdue)
}

export function isAdvanced(shipment: any): boolean {
  const atd = toDateUTC(milestone(shipment, 'atd'))
  const etd = toDateUTC(milestone(shipment, 'etd'))
  const ata = toDateUTC(milestone(shipment, 'ata'))
  const eta = toDateUTC(milestone(shipment, 'eta'))

  const atdAdvanced = atd && etd && atd < etd
  const ataAdvanced = ata && eta && ata < eta
  return !!(atdAdvanced || ataAdvanced)
}

export function isCompleted(shipment: any): boolean {
  return shipment.status === 'COMPLETED'
}

export function isDeparted(shipment: any): boolean {
  const atd = milestone(shipment, 'atd') || shipment.atd
  const ata = milestone(shipment, 'ata') || shipment.ata
  return !!atd && !ata
}

export function isArrived(shipment: any): boolean {
  return !!(milestone(shipment, 'ata') || shipment.ata)
}

export function matchesShipmentFilter(filterKey: string, shipment: any): boolean {
  switch (filterKey) {
    case SHIPMENT_FILTERS.TOTAL:
      return true
    case SHIPMENT_FILTERS.IN_TRANSIT:
      return isInTransit(shipment)
    case SHIPMENT_FILTERS.DELAYED:
      return isDelayed(shipment)
    case SHIPMENT_FILTERS.ADVANCED:
      return isAdvanced(shipment)
    case SHIPMENT_FILTERS.COMPLETED:
      return isCompleted(shipment)
    case SHIPMENT_FILTERS.DEPARTED:
      return isDeparted(shipment)
    case SHIPMENT_FILTERS.ARRIVED:
      return isArrived(shipment)
    default:
      return true
  }
}
